/**
 * 失敗の理由を、画面に出せる文言にする。
 *
 * fetch の実装や外部ライブラリは Error でないものを投げることがある。そのまま出すと
 * 「[object Object]」のような読めない文字になるので、決まった文言へ倒す。
 *
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business 読み書きに失敗した理由を、画面に出せる文言へそろえる。
 * @graph-connects none
 */

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business 投げられたものから理由の文言を取り出す。Error でなければ決まった文言にする
 * @graph-connects none
 */
export function toMessage(error: unknown): string {
  return error instanceof Error ? error.message : '通信に失敗しました';
}
